import React, { Component } from "react";
import { compose, graphql } from "react-apollo";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import { UPDATE } from "../../graphql/mutations/user";
import {
  GET_CHEF_DETAILS,
} from "../../graphql/queries/chef";
import { CUISINES } from "../../graphql/queries/dishes";
import connect from "react-redux/es/connect/connect";
import Portfolio from "../ChefSetup/portfolio";
import { NotificationManager } from "react-notifications";
import Header from "../../components/Header";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { Grid } from "@material-ui/core";
import Footer from "../../components/Footer/FooterChefSteps";
import { getChef, getUser } from "../../redux/user";

class EditPortfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  changeActiveStatus = () => {
    let {updateChef, details,userId,dispatch} = this.props;

    let chefPayload = {
      userId: this.props.userId,
      active: !details.chef.active,
    };

    this.setState({loading: true});

    updateChef({
      variables: {chef: chefPayload}
    }).then(res => {
      dispatch(getChef(userId));
      this.setState({loading: false});
    }).catch(err => {
      console.log(err);
      console.log(JSON.parse(JSON.stringify(err)));
      this.setState({loading: false});
    });
  }

  handleSubmit = mutation => (
    values,
    { setSubmitting, setStatus, resetForm }
  ) => {
    window.onload = function() {
      window.scrollTo(0, 0);
    };
    this.setState({ loading: true });
    mutation({
      variables: values
    })
      .then(res => {
        this.setState({ loading: false });

        this.props.details.refetch();
      })
      .catch(err => {
        this.setState({ loading: false });
        setStatus(err);

        let errorObj = JSON.parse(JSON.stringify(err));
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            NotificationManager.error(error.message, "Chef");
          });
        }
      });
  };

  onSavePortfollo = async payload => {
    let { updateChef, updateUser, userId, dispatch } = this.props;
    const { chef, user } = payload;
    this.setState({ loading: true });
    try {
      const resp = await updateChef({
        variables: { chef },
      });

      NotificationManager.info('Successfully updated', 'Portfolio');
      if (resp && user.hasOwnProperty('profilePic')) {
        const respUser = await updateUser({
          variables: { user: { ...user, id: userId } }
        });
        if (respUser) {
          await dispatch(getUser(userId));
          await this.props.history.push("/home/dashboard");
        }
      }

      this.props.history.push("/home/dashboard");
    } catch (err) {
      let errorObj = JSON.parse(JSON.stringify(err));
      console.log(errorObj);
      this.setState({ loading: false });
    }
  };

  render() {
    let { details } = this.props;
    return (
      <div>
        <Header history={this.props.history} />
        {this.state.loading && <LinearProgress color="primary" />}
        <Grid
          container
        >
          <Grid item md={12} xs={12} sm={12}>
            <Portfolio
              onCuisinesSubmit={this.handleSubmit}
              chef={details && details.chef ? details.chef : null}
              selected={details && details.chef ? details.chef.cuisines : []}
              {...this.props}
              cuisines={this.props.cuisinesList.cuisines || []}
              onSubmit={this.onSavePortfollo}
              updatePortfolio={this.state.hideSteps}
              history={this.props.history}
              screen='edit-protfolio'
              changeActiveStatus={this.changeActiveStatus}
            />
          </Grid>
        </Grid>
        <Footer />
      </div>
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef
  };
};
const ChefPortfolioWithData = compose(
  graphql(UPDATE_CHEF, { name: "updateChef" }),
  graphql(UPDATE, { name: "updateUser" }),
  graphql(CUISINES, {
    name: "cuisinesList",
    options: props => ({
      variables: {
        country: "US"
      }
    })
  }),
  graphql(GET_CHEF_DETAILS, {
    name: "details",
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  })
)(EditPortfolio);
const ChefPortfilio = connect(mapSateToProps)(ChefPortfolioWithData);
export default ChefPortfilio;
